import {Col, Row, Typography, Input} from "antd";
import Flex from "../../core/components/Flex";
import {dateFormat, getAge} from "../../core/utils/date-utils";
import {useEffect, useState} from "react";
import ApiService from "../../core/service/api-service";
import {t} from 'i18next'

// variant:
//  - undefined : hasta bilgisi + anamnez (eski davranış)
//  - 'header'  : sadece hasta/çekim bilgisi (modal başlığında kullanmak için, kompakt)
//  - 'anamnez' : sadece Klinik Bilgi (anamnez) alanı; başlığı çağıran (kart başlığı) verir
export default function StudyInfo({studyId, onChangeAnamnez, variant}) {
    const [study, setStudy] = useState({
        patient: {},
        modality: {}
    })
    const [anamnez, setAnamnez] = useState('')

    const showHeader = variant !== 'anamnez';
    const showAnamnez = variant !== 'header';
    const compact = variant === 'header';

    const getStudy = async () => {
        const response = await ApiService.Study.Get(studyId);
        if (response?.success) {
            setStudy(response.data)
        }
    }

    const getAnamnez = async () => {
        const response = await ApiService.StudyAnamnez.GetStudyAnamnez(studyId);
        if (response.success) {
            setAnamnez(response.data.clinicalInformation)
        }
    }

    useEffect(() => {
        if (showHeader) getStudy()
        if (showAnamnez) getAnamnez()
    }, [])

    const field = (label, value) => (
        <Flex flexDirection={'column'}>
            <Typography.Text style={{fontWeight: 'bold', fontSize: compact ? 11 : undefined, lineHeight: compact ? 1.2 : undefined, color: compact ? '#8c8c8c' : undefined}}>{label}</Typography.Text>
            <Typography.Text style={{fontSize: compact ? 13 : undefined, lineHeight: compact ? 1.2 : undefined}}>{value}</Typography.Text>
        </Flex>
    )

    return (
        <div>
            {showHeader && (
                <div style={{display: 'flex', alignItems: 'start', flexWrap: 'wrap', gap: compact ? 16 : 24}}>
                    {field(t('Hospital'), study?.hospital?.name)}
                    {field(t('Study Date'), dateFormat(study.studyDateTime))}
                    {field(t('Patient Id'), study.patient.dicomPatientId)}
                    {field(t('Patient Name'), study.patient.name)}
                    {field(t('Patient Age'), getAge(study.patient.birthdate))}
                    {field(t('Patient Gender'), t(study.patient.gender))}
                </div>
            )}

            {showHeader && showAnamnez && <br/>}

            {showAnamnez && (
                <>
                    {variant !== 'anamnez' && (
                        <Typography.Text style={{fontWeight: 'bold'}}>{t('Clinical Information')}</Typography.Text>
                    )}
                    <div>
                        <Input.TextArea
                            rows={variant === 'anamnez' ? 3 : 7}
                            value={anamnez}
                            onChange={(e) => {
                                setAnamnez(e.target.value)
                                onChangeAnamnez && onChangeAnamnez(e.target.value)
                            }}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
